import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import config from "@/config.json";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#1A1A1A] text-white">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16">
          {/* Brand */}
          <div className="space-y-5">
            <h3 className="font-heading text-2xl font-bold tracking-[0.15em]">
              {config.business.name}
            </h3>
            <p className="text-sm text-white/60 leading-relaxed max-w-xs font-body">
              {config.business.description}
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-5">
            <h4 className="text-xs uppercase tracking-[0.2em] font-bold text-[#C5A059]">
              Navigate
            </h4>
            <div className="flex flex-col gap-3">
              {[
                { label: "Home", path: "/" },
                { label: "Catalogue", path: "/catalogue" },
                { label: "Contact Us", path: "/contact" },
              ].map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                  className="text-sm text-white/60 hover:text-[#C5A059] transition-colors duration-300 font-body"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div className="space-y-5">
            <h4 className="text-xs uppercase tracking-[0.2em] font-bold text-[#C5A059]">
              Get in Touch
            </h4>
            <div className="flex flex-col gap-4">
              <a
                href={`tel:${config.contact.phone}`}
                data-testid="footer-phone"
                className="flex items-center gap-3 text-sm text-white/60 hover:text-[#C5A059] transition-colors duration-300 font-body"
              >
                <Phone size={14} className="shrink-0" />
                {config.contact.phone}
              </a>
              <a
                href={`mailto:${config.contact.email}`}
                data-testid="footer-email"
                className="flex items-center gap-3 text-sm text-white/60 hover:text-[#C5A059] transition-colors duration-300 font-body"
              >
                <Mail size={14} className="shrink-0" />
                {config.contact.email}
              </a>
              <div className="flex items-start gap-3 text-sm text-white/60 font-body">
                <MapPin size={14} className="shrink-0 mt-0.5" />
                <span>{config.contact.address}</span>
              </div>
            </div>
          </div>
        </div>

        <Separator className="my-12 bg-white/10" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40 font-body">
            &copy; {new Date().getFullYear()} {config.business.name}. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            {config.social.instagram && (
              <a
                href={config.social.instagram}
                data-testid="footer-social-instagram"
                className="text-xs uppercase tracking-[0.15em] text-white/40 hover:text-[#C5A059] transition-colors duration-300 font-body"
              >
                Instagram
              </a>
            )}
            {config.social.facebook && (
              <a
                href={config.social.facebook}
                data-testid="footer-social-facebook"
                className="text-xs uppercase tracking-[0.15em] text-white/40 hover:text-[#C5A059] transition-colors duration-300 font-body"
              >
                Facebook
              </a>
            )}
            {config.social.whatsapp && (
              <a
                href={config.social.whatsapp}
                data-testid="footer-social-whatsapp"
                className="text-xs uppercase tracking-[0.15em] text-white/40 hover:text-[#C5A059] transition-colors duration-300 font-body"
              >
                WhatsApp
              </a>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};
